/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("CarInfoController", [
            "$scope", "$http", "$routeParams", "$oidc",
            function ($scope, $http, $routeParams, oidc) {
                $scope.vin = $routeParams.vin;
                $scope.showCarInfo = false;
                $scope.showCarHistory = false;

                $scope.search = function () {
                    $http
                        .get("/api/car-info/" + $scope.vin, {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.carInfo = response.data;
                        }, function (err) {
                        });
                    $http
                        .get("/api/car-history/" + $scope.vin, {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.carHistory = response.data;
                        }, function (err) {
                        });
                };

                $scope.$watch("carInfo", function () {
                    $scope.showCarInfo = typeof $scope.carInfo != "undefined" && $scope.carInfo != null;
                });
                $scope.$watch("carHistory", function () {
                    $scope.showCarHistory = typeof $scope.carHistory != "undefined" && $scope.carHistory != null;
                });

                // On load
                $scope.search();
            }
        ]);
})();